import { useCallback, useMemo } from "react";
import { Outlet, useParams } from "react-router-dom";
import { DocumentFlowContext, DocumentFlowConfig } from "./DocumentFlowContext";
import { useTemplateEditContext } from "./TemplateEditProvider";
import { TemplateDetail } from "./TemplateCreationContext";
import { PrescriptionDetail } from "@interfaces";

export function TemplateEditFlowProvider() {
  const { requestId = "", templateId = "" } = useParams();
  const { addDetail } = useTemplateEditContext();

  const submitDetail = useCallback(
    async (detail: PrescriptionDetail) => {
      addDetail(detail as unknown as Omit<TemplateDetail, "localId">);
    },
    [addDetail],
  );

  const config: DocumentFlowConfig = useMemo(
    () => ({
      routes: {
        searchBackRoute: `/app/solicitudes/${requestId}/plantilla/${templateId}/editar`,
        treatmentRoute: `/app/solicitudes/${requestId}/plantilla/${templateId}/editar/tratamiento`,
        treatmentBackRoute: `/app/solicitudes/${requestId}/plantilla/${templateId}/editar/buscar`,
        afterSubmitRoute: `/app/solicitudes/${requestId}/plantilla/${templateId}/editar`,
      },
      labels: {
        treatmentTitle: "Detalle plantilla",
        submitButtonText: "Agregar a plantilla",
        searchTitle: "Busca el medicamento para tu plantilla",
        mobileSearchTitle: "Agregar a plantilla",
      },
      submitDetail,
      enableInteractions: false,
      showTemplatesSection: false,
    }),
    [requestId, templateId, submitDetail],
  );

  return (
    <DocumentFlowContext.Provider value={config}>
      <Outlet />
    </DocumentFlowContext.Provider>
  );
}
